(ns io.daskul.webapp.core
  "Main entry point - re-exports commonly used components."
  (:require
   ;; UI
   [io.daskul.webapp.ui :as ui]
   [io.daskul.webapp.ui.icons :as icons]

   ;; Widgets
   [io.daskul.webapp.widgets.fsm.transitions :as fsm.transitions]
   [io.daskul.webapp.widgets.form.inline-table :as inline-table]
   [io.daskul.webapp.widgets.form.selector :as selector]
   [io.daskul.webapp.widgets.form.lookup :as lookup]
   [io.daskul.webapp.widgets.form.field :as field]
   [io.daskul.webapp.widgets.display :as display]
   [io.daskul.webapp.widgets.embedded :as embedded]
   [io.daskul.webapp.widgets.layout.sidebar :as sidebar]

   ;; Aggregates
   [io.daskul.webapp.aggregates.events :as agg.events]
   [io.daskul.webapp.aggregates.subs :as agg.subs]

   ;; Panel state
   [io.daskul.webapp.panel.events :as panel.events]
   [io.daskul.webapp.panel.subs :as panel.subs]

   ;; Aggregate views
   [io.daskul.webapp.views.aggregate :as views.agg]

   ;; Hooks
   [io.daskul.webapp.hooks.aggregates :as hooks.agg]
   [io.daskul.webapp.hooks.list :as hooks.list]

   ;; Effects
   [io.daskul.webapp.effects.core :as effects]))

;; ============================================================================
;; Re-export key components
;; ============================================================================

;; FSM Widgets
(def transitions-panel fsm.transitions/transitions-panel)
(def transition-action-panel fsm.transitions/transition-action-panel)

;; Form Widgets
(def inline-table-widget inline-table/inline-table-widget)
(def selector-field selector/selector-field)
(def lookup-field lookup/lookup-field)
(def form-field field/form-field)
(def form-level-error-message field/form-level-error-message)
(def schema->input-type field/schema->input-type)
(def enum-options field/enum-options)
(def multi-select-options field/multi-select-options)

;; Display Widgets
(def render-display-value display/render-display-value)

;; Embedded Widgets
(def embedded-form-modal embedded/embedded-form-modal)
(def embedded-list embedded/embedded-list)

;; Layout Widgets
(def edit-sidebar sidebar/edit-sidebar)

;; Panel State
(def close-panel-db panel.events/close-panel-db)

;; Aggregate Views
(def aggregate-page views.agg/aggregate-page)
(def configure-views! views.agg/configure!)

;; Hooks
(def use-aggregate hooks.agg/use-aggregate)
(def use-current-aggregate hooks.agg/use-current-aggregate)
(def use-aggregate-list hooks.agg/use-aggregate-list)
(def use-aggregate-record hooks.agg/use-aggregate-record)
(def use-aggregate-form hooks.agg/use-aggregate-form)
(def use-aggregate-delete hooks.agg/use-aggregate-delete)
(def use-fsm hooks.agg/use-fsm)
(def use-list hooks.list/use-list)
(def use-list-params hooks.list/use-list-params)

;; ============================================================================
;; Configuration
;; ============================================================================

(defn configure!
  "Configure the webapp library.

   Options:
   - :api-base - Base URL for API requests (default: \"/api\")
   - :auth-header - Function that returns auth header map
   - :on-navigate - Function called on successful operations"
  [opts]
  (agg.events/configure! opts)
  (when-let [nav-fn (:on-navigate opts)]
    (effects/set-navigate-fn! nav-fn)))

;; ============================================================================
;; Namespace re-exports for consumer convenience
;; Users can also import directly: io.daskul.webapp.ui, io.daskul.webapp.ui.icons
;; ============================================================================
;; Note: Namespace aliases (agg.events, agg.subs) can't be re-exported as vars
;; in ClojureScript. Consumers should import the namespaces directly:
;;   [io.daskul.webapp.aggregates.events :as agg.events]
;;   [io.daskul.webapp.aggregates.subs :as agg.subs]
